import React, { useEffect, useState, SyntheticEvent } from "react";
import { useNavigate } from "react-router-dom";
import { DateValueType } from "react-tailwindcss-datepicker"; // Adjust the import path as needed
import { ACTIONS, KEYS, URLS } from "../../_config";
import { useDispatch } from "react-redux";
import SideMenuBar from "../../components/sideMenuBar";
import SentimentTimeline from "./sentimentTimeline";
import Icon from "../../components/icons";
// import FilterModal from './filterModal';
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import SentimentBreakdown from "./sentimentBrakdown";
import SentimentOverall from "./sentimentOverall";
import ReviewVolumn from "./reviewVolumn";
import ReviewStars from "./reviewStars";
import moment from "moment";
import {
  useAuthStatus,
  useStoreSelector,
  useStoreBrnDSSelector,
} from "../../store/selectors/userSelector";
import Filter from "../../components/filter";
import { useFilterSelector } from "../../store/selectors/filterSelector";
import SentimentComparison from "./sentimentComparision";
import "./style.css";
import Spinner from "../../components/iconSvgs/spinner";
import Header from "../../components/header";
import { useMenuToggleSelector } from "../../store/selectors/menuToggleSelector";
import { store } from "../../store";

const Sentiment: React.FC = () => {
  const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
  const savedFilter = useFilterSelector();
  const filterValue = savedFilter.applied ?? {};
  const [totalReviewCount, setTotalReviewCount] = useState<number | null>(null);
  const [averageReviewCount, setAverageReviewCount] = useState<number | null>(
    null
  );
  const [overallAvgRatingCount, setOverallAvgRatingCount] = useState<
    number | null
  >(null);

  // console.log('store =>', store);
  // console.log('branchDS =>', branchDS);

  const handleTotalReviewCount = (totalCount: number) => {
    setTotalReviewCount(totalCount);
  };

  const handleAverageReviewCount = (averageCount: number) => {
    setAverageReviewCount(averageCount);
  };

  const handleOverallAvgRatingCount = (averageCount: number) => {
    setOverallAvgRatingCount(averageCount);
  };

  const handleApplyFilter = (_filterData: any) => {
    // filter state is managed by Redux via Filter component
  };

  const handleClearFilter = () => {
    // filter state is managed by Redux via Filter component
  };

  useEffect(() => {
    setOnSubmitLoading(true);
    setTimeout(() => {
        setOnSubmitLoading(false);
    }, 2000);
  }, []);

  return (
    <div className="flex">
      
      <SideMenuBar sideMenuBarClass={"w-64 h-screen bg-white "} />

      <div
        className="flex flex-col w-full bg-sky-50 overflow-y-auto"
        style={{ maxHeight: "100vh" }}
      >
        <Header />
        <div className="p-8">
          <h1 className="text-xl font-semibold text-gray-500 mb-2">
            Sentiment
          </h1>

          {/* Paragraph */}
          <p className="text-sm text-gray-600 mb-6 ">
            A unified dashboard presenting real‑time sentiment scores, trends,
            and key metrics.
          </p>

          <div className="flex justify-between mb-5 ipad-column">
            {/* Main Content (Sentiment Timeline, Overall Sentiment, Breakdown, etc.) */}
            <div className="flex-1 ipad-order-2">
              <div className="bg-white shadow-lg rounded-2xl p-6 mb-5">
                <h1 className="text-base font-semibold text-gray-500 mb-4">
                  Sentiment Timeline
                </h1>

                <SentimentTimeline filterValue={filterValue} />
              </div>

              <div className="flex space-x-4">
                <SentimentComparison filterValue={filterValue} />
              </div>

              <div className="flex space-x-4 ipad-small-column">
                {/* First Card */}
                <div className="bg-white shadow-lg rounded-2xl p-6 mb-5 flex-1">
                  <h1 className="text-base font-semibold text-gray-500 mb-4">
                    Overall Sentiment
                  </h1>

                  <SentimentOverall filterValue={filterValue} />
                </div>

                {/* Second Card */}
                <div className="bg-white shadow-lg rounded-2xl p-6 mb-5 flex-1 ipad-small-ml-0">
                  <h1 className="text-base font-semibold text-gray-500 mb-4">
                    Sentiment Breakdown
                  </h1>

                  <SentimentBreakdown filterValue={filterValue} />
                </div>
              </div>

              <div className="flex space-x-4 ipad-small-column">
                {/* First Card */}
                <div className="bg-white shadow-lg rounded-2xl p-6 mb-5 flex-1">
                  <h1 className="text-base font-semibold text-gray-500 mb-4">
                    Review Volume
                  </h1>

                  <h1 className="text-xl font-semibold text-gray-600">
                    {totalReviewCount}
                  </h1>
                  {/* <div className="flex w-32 bg-gray-300 rounded-full h-2 mb-2">
                                    <div className="h-2 bg-green-500 rounded-l-full mr-1" style={{ width: `35%` }}></div>
                                    <div className="h-2 bg-yellow-500 mr-1" style={{ width: `10%` }}></div>
                                    <div className="h-2 bg-gray-500 rounded-r-full" style={{ width: `20%` }}></div>
                                    <div className="h-2 bg-red-500 rounded-r-full" style={{ width: `35%` }}></div>
                                </div> */}
                  <h1 className="text-sm text-gray-400 mb-4">
                    Reviews(Avg {averageReviewCount} per day){" "}
                  </h1>

                  <ReviewVolumn
                    filterValue={filterValue}
                    onTotalReviewCount={handleTotalReviewCount}
                    onAverageReviewCount={handleAverageReviewCount}
                  />
                </div>

                {/* Second Card */}
                <div className="bg-white shadow-lg rounded-2xl p-6 mb-5 flex-1 ipad-small-ml-0">
                  <h1 className="text-base font-semibold text-gray-500 mb-4">
                    Review Stars
                  </h1>
                  <h1 className="text-lg font-semibold text-gray-600 ">
                    {overallAvgRatingCount}
                  </h1>
                  <h1 className="text-sm text-gray-400 mb-4">Average Rating</h1>

                  <ReviewStars
                    filterValue={filterValue}
                    onOverallAvgRating={handleOverallAvgRatingCount}
                  />
                </div>
              </div>
            </div>

            {/* Accordion Filter on the Right */}
            
              <Filter
                onApplyFilter={handleApplyFilter}
                onClearFilter={handleClearFilter}
                filterClass={"w-80 bg-white shadow-lg rounded-2xl p-6 ml-4 top-20 sticky h-[450px] ipad-static ipad-order-1 ipad-width-100 ipad-mb-2 "}
              />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sentiment;
